import {ActionTypes} from "modules/redux_types";
import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

const types = ["CLIENT_CONTEXTS_FETCH", "CLIENT_CONTEXT_CREATE"] as const;

types.forEach(type => createReduxPromiseActionType(actionTypes, type));

export type ActionType = typeof types[number];

export type ClientContextActionTypes = ActionTypes<ActionType>;

export default actionTypes as ClientContextActionTypes;
